"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingSettingsWrite = exports.ReportingSettings = void 0;
const zod_1 = require("zod");
/** Display fallback only; never influences weights, risk or signed replica settings. */
exports.ReportingSettings = zod_1.z
    .object({
    reportingCurrency: zod_1.z
        .string()
        .regex(/^[A-Z]{3}$/)
        .nullable(),
    revision: zod_1.z.string().regex(/^(0|[1-9][0-9]{0,17})$/),
})
    .strict();
exports.ReportingSettingsWrite = zod_1.z
    .object({
    reportingCurrency: zod_1.z
        .string()
        .regex(/^[A-Z]{3}$/)
        .nullable(),
    expectedRevision: zod_1.z.string().regex(/^(0|[1-9][0-9]{0,17})$/),
    reason: zod_1.z.string().trim().min(1).max(500),
})
    .strict();
//# sourceMappingURL=securescale-reporting-settings.js.map